import { render, staticRenderFns } from "./ShopsList.vue?vue&type=template&id=ab053688"
import script from "./ShopsList.vue?vue&type=script&lang=js"
export * from "./ShopsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports